import { render, staticRenderFns } from "./distributionOrderSplitting.vue?vue&type=template&id=66b6588c&scoped=true&"
import script from "./distributionOrderSplitting.vue?vue&type=script&lang=js&"
export * from "./distributionOrderSplitting.vue?vue&type=script&lang=js&"
import style0 from "./distributionOrderSplitting.vue?vue&type=style&index=0&id=66b6588c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b6588c",
  null
  
)

export default component.exports